import { buildProps } from '@vuesax-alpha/utils'

export const sidebarGroupProps = buildProps({
  open: Boolean,
} as const)
